import { createStore } from "vuex";
import axios from "axios";

const store = createStore({
  state() {
    return {
      isDev: false,
      isLight: true,
      alertIsOpen: false,
      disclaimerIsOpen: false,
      data: [],
      isLoading: false,
      dataLoaded: false,
      serverResponse: {
        error: false,
        status: "",
      },
      progressInfo: "",
      progressWidth: 0,
      isHomePage: true,
      searchCount: 0,
      searchCountCookie: "",
      calcIsOpen: false,
    };
  },
  mutations: {
    openCalc(state, payload) {
      state.calcIsOpen = payload;
    },
    switchSearchMode(state) {
      state.isDev = !state.isDev;
    },
    toggleLightMode(state, payload) {
      state.isLight = !state.isLight || payload;
    },
    openAlert(state, payload) {
      state.alertIsOpen = payload;
    },
    openDisclaimer(state, payload) {
      state.disclaimerIsOpen = !state.disclaimerIsOpen || payload;
    },
    isHomePage(state, payload) {
      state.isHomePage = payload;
    },
    isLoading(state, payload) {
      state.isLoading = payload;
    },
    dataLoaded(state, payload) {
      state.dataLoaded = payload;
    },
    loadData(state, payload) {
      state.data = payload;
    },
    isError(state, payload) {
      state.serverResponse = payload;
    },
    progressBarStatus(state, payload) {
      state.progressInfo = payload.message;
      state.progressWidth = payload.width;
    },
    setSearchCookie(state) {
      const Today = new Date(Date.now());
      const Key = (Today.getMonth() + "-" + Today.getFullYear()).toString();
      state.searchCount++;
      state.searchCountCookie = {
        id: Key,
        count: state.searchCount,
      };
    },
  },
  actions: {
    openCalc(context, payload) {
      context.commit("openCalc", payload);
    },
    switchSearchMode(context, payload) {
      context.commit("switchSearchMode", payload);
    },
    toggleLightMode(context, payload) {
      context.commit("toggleLightMode", payload);
    },
    openAlert(context, payload) {
      context.commit("openAlert", payload);
    },
    openDisclaimer(context, payload = false) {
      context.commit("openDisclaimer", payload);
    },
    isLoading(context, payload) {
      context.commit("isLoading", payload);
    },
    isHomePage(context, payload) {
      context.commit("isHomePage", payload);
    },
    loadData(context, payload) {
      context.commit("isLoading", true);
      context.commit("dataLoaded", false);
      context.commit("isHomePage", false);
      context.commit("progressBarStatus", {
        message: `You searched for <span class="output" data-v-1138bb63>${payload.stockName}</span>`,
        width: 0,
      });
      setTimeout(() => {
        context.commit("progressBarStatus", {
          message: `Scanning for <span class="output" data-v-1138bb63>${payload.stockName}</span>'s details`,
          width: 10,
        });
        setTimeout(() => {
          context.commit("progressBarStatus", {
            message: `Scanning for <span class="output" data-v-1138bb63>${payload.stockName}</span>'s details`,
            width: 30,
          });
          setTimeout(() => {
            context.commit("progressBarStatus", {
              message: `Gathering <span class="output" data-v-1138bb63>${payload.stockName}</span>'s resources`,
              width: 50,
            });
          }, 1400);
        }, 1400);
      }, 1400);
      axios
        .get(payload.url)
        .then((response) => {
          /* 
                        Remember to update the scoped CSS (data-v-1138bb63 or similar depends on build) id below span tag 
                        injections after doing npm run build in dist js file and here below on template syntaxes for 
                        progressBarStatus's message properties
                    */
          context.commit("progressBarStatus", {
            message: `Performing analytics on <span class="output" data-v-1138bb63>${payload.stockName}</span>'s acquired data`,
            width: 75,
          });
          setTimeout(() => {
            if (response.data.Status === 404) {
              context.commit("progressBarStatus", {
                message: `Something went wrong when searching for <span class="output" data-v-1138bb63>${payload.stockName}</span>`,
                width: 100,
              });
              setTimeout(() => {
                context.commit("loadData", response.data);
                context.commit("isLoading", false);
                context.commit("dataLoaded", true);
              }, 500);
            }
            if (response.data.Status === 200) {
              context.commit("progressBarStatus", {
                message: `Generating and rendering <span class="output" data-v-1138bb63>${payload.stockName}</span>'s report`,
                width: 100,
              });
              setTimeout(() => {
                context.commit("setSearchCookie");
                context.commit("loadData", response.data);
                context.commit("isLoading", false);
                context.commit("dataLoaded", true);
              }, 500);
            }
            // console.log(response.data);
          }, 500);
        })
        .catch((err) => {
          context.commit("progressBarStatus", {
            message: "Something went wrong...",
            width: 75,
          });
          setTimeout(() => {
            context.commit("progressBarStatus", {
              message: "Preparing report",
              width: 100,
            });
            setTimeout(() => {
              console.log(err);
              if (
                err.message.includes(404) ||
                err.message.includes("Network Error")
              ) {
                context.commit("isError", {
                  error: true,
                  status: 404,
                });
              }
              if (err.message.includes(503)) {
                context.commit("isError", {
                  error: true,
                  status: 503,
                });
              }
              context.commit("isLoading", false);
              context.commit("dataLoaded", false);
            }, 500);
          }, 500);
        });
    },
    dataLoaded(context, payload) {
      context.commit("dataLoaded", payload);
    },
    isError(context, payload) {
      context.commit("isLoading", true);
      context.commit("isError", payload);
      context.commit("isLoading", false);
    },
  },
  getters: {
    calcIsOpen(state) {
      return state.calcIsOpen;
    },
    checkIsDev(state) {
      return state.isDev;
    },
    checkIsLight(state) {
      return state.isLight;
    },
    alertIsOpen(state) {
      return state.alertIsOpen;
    },
    disclaimerIsOpen(state) {
      return state.disclaimerIsOpen;
    },
    loadData(state) {
      return state.data;
    },
    isLoading(state) {
      return state.isLoading;
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    isError(state) {
      return state.serverResponse;
    },
    progressBarStatus(state) {
      return {
        message: state.progressInfo,
        width: state.progressWidth,
      };
    },
    isHomePage(state) {
      return state.isHomePage;
    },
    searchCountCookie(state) {
      return state.searchCountCookie;
    },
  },
});

export default store;
